<template>
  <el-card>
    <el-form ref="form" :model="user" label-width="80px">
      <el-form-item label="推荐上线">
        <el-row :gutter="12">
          <el-card>
            <el-col :span="3"><div>推荐上线:</div></el-col>
            <el-col :span="21">
              <span v-if="!user.parent_user">无上线</span>
              <span v-else>{{ user.parent_user.username }}({{ user.parent_user.real_name }})</span>
              &nbsp;
              <el-button v-if="hasPermsChangeParent" type="primary" plain icon="el-icon-edit" size="mini" @click="showUpdateParentDialog" />
            </el-col>
            <el-col :span="3"><div>安置上线:</div></el-col>
            <el-col :span="21">
              <span v-if="!user.posit_parent_user">无上线</span>
              <span v-else>{{ user.posit_parent_user.username }}({{ user.posit_parent_user.real_name }})</span>
              &nbsp;
              <el-button
                v-if="hasPermsChangePositParent"
                type="primary"
                plain
                icon="el-icon-edit"
                size="mini"
                @click="showUpdatePositParentDialog"
              />
            </el-col>
            <el-col :span="3"><div>手机号码:</div></el-col>
            <el-col :span="21">
              {{ user.username }} &nbsp;
              <el-button v-if="hasPermsChangeMobile" type="primary" plain icon="el-icon-edit" size="mini" @click="showUpdateMobileDialog" />
            </el-col>
          </el-card>
        </el-row>
      </el-form-item>

      <el-form-item label="奖金开关">
        <el-row>
          <el-card>
            <el-col
              ><el-alert
                title="(注：资格是用户拿到奖金的必要条件，但能否拿到还取决于各奖项的角色限定与考核机制)"
                type="warning"
                :closable="false"
            /></el-col>
            <el-col :span="3"><div>推荐奖金资格</div></el-col>
            <el-col :span="21">
              {{ user.allow_invite_rebate ? '正常' : '禁用' }}
              <el-popconfirm
                v-if="hasPermsAllowInviteRebate"
                confirm-button-text="确认"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                title="确认要执行操作？"
                @confirm="onToggleAllowInviteRebate"
              >
                <el-button slot="reference" :type="user.allow_invite_rebate ? 'warning' : 'primary'" size="mini" plain>
                  {{ user.allow_invite_rebate ? '设为禁用' : '恢复正常' }}
                </el-button>
              </el-popconfirm>
            </el-col>
            <el-col :span="3"><div>复销奖金资格</div></el-col>
            <el-col :span="21">
              {{ user.allow_order_rebate ? '正常' : '禁用' }}

              <el-popconfirm
                v-if="hasPermsAllowOrderRebate"
                confirm-button-text="确认"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                title="确认要执行操作？"
                @confirm="onToggleAllowOrderRebate"
              >
                <el-button slot="reference" :type="user.allow_order_rebate ? 'warning' : 'primary'" size="mini" plain>
                  {{ user.allow_order_rebate ? '设为禁用' : '恢复正常' }}
                </el-button>
              </el-popconfirm>
            </el-col>
            <el-col :span="3"><div>基金分红资格</div></el-col>
            <el-col :span="21">
              {{ user.allow_share_fund ? '正常' : '禁用' }}
              <el-popconfirm
                v-if="hasPermsAllowShareFund"
                confirm-button-text="确认"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                title="确认要执行操作？"
                @confirm="onToggleAllowShareFund()"
              >
                <el-button slot="reference" :type="user.allow_share_fund ? 'warning' : 'primary'" size="mini" plain>
                  {{ user.allow_share_fund ? '设为禁用' : '恢复正常' }}
                </el-button>
              </el-popconfirm>
            </el-col>
          </el-card>
        </el-row>
      </el-form-item>

      <el-form-item label="变更日志">
        <el-card>
          <el-table :data="user.user_change_logs" style="width: 100%" :default-sort="{ prop: 'created_at', order: 'descending' }">
            <el-table-column prop="id" label="" width="90" />
            <el-table-column prop="op_name" label="操作人" width="100" />
            <el-table-column prop="created_at" label="操作时间" width="170" />
            <el-table-column prop="log_text" label="备注" />
          </el-table>
        </el-card>
      </el-form-item>
    </el-form>

    <el-dialog title="修改推荐上线" :visible.sync="updateParentDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="parentForm"
        :submit="onUpdateParent"
        :errors.sync="errors"
        :model="parentForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="当前推荐上线">
          <span v-if="!user.parent_user">无上线</span>
          <span v-else>{{ user.parent_user.username }}({{ user.parent_user.real_name }})</span>
        </el-form-item>
        <el-form-item label="更改为" required prop="username"><el-input v-model="parentForm.username" placeholder="手机号"/></el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog title="修改安置上线" :visible.sync="updatePositParentDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="parentForm"
        :submit="onUpdatePositParent"
        :errors.sync="errors"
        :model="parentForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="当前安置上线">
          <span v-if="!user.posit_parent_user">无上线</span>
          <span v-else>{{ user.posit_parent_user.username }}({{ user.posit_parent_user.real_name }})</span>
        </el-form-item>
        <el-form-item label="更改为" required prop="username"><el-input v-model="parentForm.username" placeholder="手机号"/></el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog title="修改手机号" :visible.sync="updateMobileDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="parentForm"
        :submit="onUpdateMobile"
        :errors.sync="errors"
        :model="parentForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="当前手机号">
          <span>{{ user.mobile }}</span>
        </el-form-item>
        <el-form-item label="更改为" required prop="username"><el-input v-model="parentForm.username" placeholder="手机号"/></el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import {
  changeParent,
  changePositParent,
  changeMobile,
  toggleAllowInviteRebate,
  toggleAllowOrderRebate,
  toggleAllowShareFund,
} from '@/api/users'
import { can } from '@/libs/utils'

export default {
  name: 'UserDetailRelations',
  components: {
    LzForm,
  },
  props: {
    user: Object,
  },
  mixins: [FormHelper],
  data() {
    return {
      formField: 'parentForm',
      updateParentDialog: false,
      updatePositParentDialog: false,
      updateMobileDialog: false,
      parentForm: {
        username: '',
      },
      errors: {},
      hasPermsChangeParent: false,
      hasPermsChangePositParent: false,
      hasPermsChangeMobile: false,
      hasPermsAllowInviteRebate: false,
      hasPermsAllowOrderRebate: false,
      hasPermsAllowShareFund: false,
    }
  },
  computed: {},
  methods: {
    showUpdateParentDialog() {
      this.parentForm.username = ''
      this.updateParentDialog = true
    },
    showUpdatePositParentDialog() {
      this.parentForm.username = ''
      this.updatePositParentDialog = true
    },
    showUpdateMobileDialog() {
      this.parentForm.username = ''
      this.updateMobileDialog = true
    },
    async onUpdateParent() {
      const { data } = await changeParent(this.resourceId, this.parentForm)
      this.updateParentDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onUpdatePositParent() {
      const { data } = await changePositParent(this.resourceId, this.parentForm)
      this.updatePositParentDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onUpdateMobile() {
      const { data } = await changeMobile(this.resourceId, this.parentForm)
      this.updateMobileDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onToggleAllowInviteRebate() {
      const { data } = await toggleAllowInviteRebate(this.resourceId, {})
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onToggleAllowOrderRebate() {
      const { data } = await toggleAllowOrderRebate(this.resourceId, {})
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onToggleAllowShareFund() {
      const { data } = await toggleAllowShareFund(this.resourceId, {})
      // 刷新用户信息
      this.$emit('refreshData')
    },
  },
  created() {
    this.hasPermsChangeParent = can('users.change-parent')
    this.hasPermsChangePositParent = can('users.change-posit-parent')
    this.hasPermsChangeMobile = can('users.change-mobile')
    this.hasPermsAllowInviteRebate = can('users.allow-invite-rebate')
    this.hasPermsAllowOrderRebate = can('users.allow-order-rebate')
    this.hasPermsAllowShareFund = can('users.allow-share-fund')
  },
}
</script>

<style></style>
